import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const SuggestionList = ({ data = [] }) => {
  const list = data.map(ad => (
    <li key={ad.id} className="suggestion">
      <a href={`/items/${ad.id}`} className="suggestion__link">
        {ad.id}
      </a>
    </li>
  ));

  return <ul className="suggestion-list">{list}</ul>;
};

SuggestionList.propTypes = {
  data: PropTypes.array
};

export default SuggestionList;
